import type { M365Acquisition } from "../types";

export function getClientTitleId(acquisition: M365Acquisition): string {
    return acquisition.appId ?? acquisition.titleId;
}
